import {
    Table,
    TableBody,
    TableCell,
    TableRow,
    Typography,
} from "@mui/material";
import { RichTreeView } from "@mui/x-tree-view";
import { useTranslation } from "react-i18next";

import { InsightsAsset, LegacyBenchmarkType } from "graphql-types/graphql";
import { useBenchmarkTranslations } from "hooks";
import { useAssetFilterTranslations } from "hooks/useAssetFilterTranslations";

import { S } from "./building-data.styles";
import {
    formatPropertyTree,
    getAssetBuildings,
} from "../../Overview/overview.utils";

type Props = {
    asset: InsightsAsset;
};

export const BuildingDataView = (props: Props) => {
    const { asset } = props;

    const { t } = useTranslation();
    const { translations } = useAssetFilterTranslations();
    const benchmark = useBenchmarkTranslations();

    const [property] = getAssetBuildings(asset.properties);

    const bfeTree = formatPropertyTree(asset.properties);

    const nationalPropertyType = `${
        benchmark.translations[
            `${LegacyBenchmarkType.BBR_PROPERTY_TYPE}-${property.nationalPropertyType}`
        ]
    } (${property.nationalPropertyType})`;

    const address = asset.name || property.fullAddress;

    return (
        <S.View>
            <Table>
                <TableBody>
                    <TableRow>
                        <TableCell>
                            <Typography variant="h5" fontWeight="bold">
                                {t("legacyNext.address", "address")}
                            </Typography>
                        </TableCell>
                        <TableCell>
                            <Typography variant="body2">{address}</Typography>
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>
                            <Typography variant="body2" fontWeight="bold">
                                {t(
                                    "assetDetailsComponent.propertyList.title",
                                    "properties"
                                )}
                            </Typography>
                        </TableCell>
                        <TableCell>
                            <RichTreeView items={bfeTree} />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>
                            <Typography variant="body2" fontWeight="bold">
                                {t(
                                    "assetDetailsComponent.propertyType",
                                    "property type"
                                )}
                            </Typography>
                        </TableCell>
                        <TableCell>
                            <Typography variant="body2">
                                {
                                    translations[
                                        property.propertyType as keyof typeof translations
                                    ]
                                }
                            </Typography>
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>
                            <Typography variant="body2" fontWeight="bold">
                                {t(
                                    "assetDetailsComponent.constructionYear",
                                    "construction year"
                                )}
                            </Typography>
                        </TableCell>
                        <TableCell>
                            <Typography variant="body2">
                                {property.constructionYear}
                            </Typography>
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>
                            <Typography variant="body2" fontWeight="bold">
                                {t(
                                    "assetDetailsComponent.nationalPropertyType",
                                    "national property type"
                                )}
                            </Typography>
                        </TableCell>
                        <TableCell>
                            <Typography variant="body2">
                                {nationalPropertyType}
                            </Typography>
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </S.View>
    );
};
